import React from 'react';
import { useTranslation } from "react-i18next";
import DefaultFooter from "../components/default-footer";
import DefaultHeader from "../components/default-header";

const LegalDisclaimer = () => {
  const { t } = useTranslation();

  return (
    <>
      <style>{`
        /* ── LEGAL DISCLAIMER STYLES ── */
        .disclaimer-wrap {
          background: #fff;
          border-radius: 20px;
          padding: 40px 44px;
          box-shadow: 0 8px 48px rgba(41,75,90,0.10);
        }
        .disclaimer-title {
          font-size: 28px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 8px;
        }
        .disclaimer-subtitle {
          font-size: 14px;
          color: #8aa5b0;
          margin-bottom: 32px;
        }
        .disclaimer-divider {
          height: 2px;
          background: linear-gradient(90deg, #294b5a 0%, #D3BE76 100%);
          border-radius: 2px;
          margin-bottom: 28px;
          width: 80px;
        }
        .disclaimer-section {
          margin-bottom: 32px;
        }
        .disclaimer-section:last-child {
          margin-bottom: 0;
        }
        .disclaimer-section-title {
          font-size: 18px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .disclaimer-section-title .badge {
          font-size: 10px;
          font-weight: 600;
          color: #fff;
          background: #294b5a;
          padding: 2px 10px;
          border-radius: 20px;
          letter-spacing: 0.5px;
        }
        .disclaimer-section p {
          font-size: 14px;
          line-height: 1.8;
          color: #3d5a66;
          margin-bottom: 10px;
        }
        .disclaimer-section ul {
          list-style: none;
          padding: 0;
          margin: 8px 0 0 0;
        }
        .disclaimer-section ul li {
          font-size: 14px;
          line-height: 1.8;
          color: #3d5a66;
          padding-left: 20px;
          position: relative;
          margin-bottom: 4px;
        }
        .disclaimer-section ul li::before {
          content: "•";
          position: absolute;
          left: 0;
          color: #D3BE76;
          font-weight: 700;
        }
        .disclaimer-highlight {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          border-left: 3px solid #D3BE76;
          margin-top: 6px;
        }
        .disclaimer-highlight p {
          margin-bottom: 0;
        }
        .disclaimer-warning {
          background: #fff8e1;
          padding: 16px 20px;
          border-radius: 10px;
          border-left: 3px solid #f9a825;
          margin-top: 6px;
        }
        .disclaimer-warning p {
          margin-bottom: 0;
          color: #5d4037;
        }
        .disclaimer-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-top: 8px;
        }
        .disclaimer-card {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          border-left: 3px solid #294b5a;
        }
        .disclaimer-card h4 {
          font-size: 14px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 4px;
        }
        .disclaimer-card p {
          font-size: 13px;
          color: #3d5a66;
          margin-bottom: 0;
          line-height: 1.6;
        }

        .disclaimer-company-badge {
          background: linear-gradient(135deg, #f7fafc 0%, #e8eef1 100%);
          border-radius: 12px;
          padding: 20px 24px;
          border: 1.5px solid #dde6ea;
          margin-bottom: 20px;
        }
        .disclaimer-company-badge h4 {
          font-size: 14px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 4px;
        }
        .disclaimer-company-badge p {
          font-size: 13px;
          color: #3d5a66;
          margin-bottom: 0;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #294b5a;
          text-decoration: none;
          margin-bottom: 24px;
          transition: color 0.2s;
        }
        .back-link:hover {
          color: #D3BE76;
        }
        .back-link svg {
          width: 16px;
          height: 16px;
          stroke: currentColor;
          fill: none;
          stroke-width: 2.5;
        }

        .disclaimer-icon-box {
          display: flex;
          align-items: center;
          gap: 12px;
          background: #f7fafc;
          padding: 12px 16px;
          border-radius: 8px;
          margin-bottom: 10px;
        }
        .disclaimer-icon-box .icon {
          font-size: 20px;
          min-width: 32px;
        }
        .disclaimer-icon-box .text {
          font-size: 13px;
          color: #3d5a66;
        }

        @media (max-width: 768px) {
          .disclaimer-wrap { padding: 28px 20px; }
          .disclaimer-title { font-size: 22px; }
          .disclaimer-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="header-margin"></div>
      <DefaultHeader />

      <section style={{ paddingTop: '20px' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">

              {/* ── BACK LINK ── */}
              <a href="/" className="back-link">
                <svg viewBox="0 0 24 24">
                  <line x1="19" y1="12" x2="5" y2="12"/>
                  <polyline points="12 19 5 12 12 5"/>
                </svg>
                {t("backToHome", { defaultValue: "Back to Home" })}
              </a>

              {/* ── LEGAL DISCLAIMER CONTENT ── */}
              <div className="disclaimer-wrap">

                {/* Heading */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                  <div style={{ width: "36px", height: "2px", background: "linear-gradient(90deg,#294b5a,#D3BE76)", borderRadius: "2px" }}></div>
                  <span style={{ fontSize: "11px", fontWeight: 700, color: "#294b5a" }}>{t("legalDisclaimerLabel", { defaultValue: "Legal Disclaimer" })}</span>
                </div>
                <h1 className="disclaimer-title">{t("legalDisclaimerTitle", { defaultValue: "Legal Disclaimer" })}</h1>
                <p className="disclaimer-subtitle">{t("legalDisclaimerSubtitle", { defaultValue: "Last updated: January 2026" })}</p>
                <div className="disclaimer-divider"></div>

                {/* ── Company Info ── */}
                <div className="disclaimer-company-badge">
                  <h4>{t("disclaimerCompanyInfo", { defaultValue: "Company Information" })}</h4>
                  <p>{t("disclaimerCompanyText", { defaultValue: "This website, silverjarz.com, is owned and operated by SilverJarz trading contracting (License No. 2404940.01). We are a private, independent agency specializing in travel consultancy and OMAN visa documentation support." })}</p>
                </div>

                {/* ── Main Disclaimer ── */}
                <div className="disclaimer-section">
                  <div className="disclaimer-warning">
                    <p><strong>{t("disclaimerImportant", { defaultValue: "⚠️ Important Notice:" })}</strong></p>
                    <p>{t("disclaimerMain", { defaultValue: "Please be aware that silverjarz.com is a non-governmental entity and is not affiliated with, endorsed by, or connected to the OMAN government or any official immigration authority. Our professional services incur a service fee separate from mandatory government fees." })}</p>
                  </div>
                </div>

                {/* ── Key Points ── */}
                <div className="disclaimer-section">
                  <div className="disclaimer-section-title">
                    {t("keyPointsTitle", { defaultValue: "Key Points to Understand" })}
                    <span className="badge">{t("important", { defaultValue: "Important" })}</span>
                  </div>

                  <div className="disclaimer-grid">
                    <div className="disclaimer-card">
                      <h4>{t("privateAgency", { defaultValue: "Private Agency" })}</h4>
                      <p>{t("privateAgencyText", { defaultValue: "We are a private sector advisory and facilitation service provider, not a government entity." })}</p>
                    </div>
                    <div className="disclaimer-card">
                      <h4>{t("serviceFees", { defaultValue: "Service Fees" })}</h4>
                      <p>{t("serviceFeesText", { defaultValue: "Our professional services incur a service fee separate from mandatory government visa fees." })}</p>
                    </div>
                    <div className="disclaimer-card">
                      <h4>{t("governmentOption", { defaultValue: "Government Option" })}</h4>
                      <p>{t("governmentOptionText", { defaultValue: "Individuals who wish to apply for a visa independently can do so through official government portals at a reduced cost." })}</p>
                    </div>
                    <div className="disclaimer-card">
                      <h4>{t("facilitationOnly", { defaultValue: "Facilitation Only" })}</h4>
                      <p>{t("facilitationOnlyText", { defaultValue: "We assist in facilitating administrative procedures for travel documentation but do not make approval decisions." })}</p>
                    </div>
                  </div>
                </div>

                {/* ── Detailed Information ── */}
                <div className="disclaimer-section">
                  <div className="disclaimer-section-title">
                    {t("detailedInfo", { defaultValue: "Detailed Information" })}
                    <span className="badge">{t("details", { defaultValue: "Details" })}</span>
                  </div>

                  <div className="disclaimer-icon-box">
                    <span className="icon">🏢</span>
                    <span className="text"><strong>{t("entityType", { defaultValue: "Entity Type:" })}</strong> {t("entityTypeText", { defaultValue: "Private limited company registered in khasab musandam, OMAN" })}</span>
                  </div>
                  <div className="disclaimer-icon-box">
                    <span className="icon">📋</span>
                    <span className="text"><strong>{t("license", { defaultValue: "License:" })}</strong> {t("licenseText", { defaultValue: "SilverJarz trading contracting - License No. 2404940.01" })}</span>
                  </div>
                  <div className="disclaimer-icon-box">
                    <span className="icon">🔗</span>
                    <span className="text"><strong>{t("affiliation", { defaultValue: "Affiliation:" })}</strong> {t("affiliationText", { defaultValue: "Independent - Not affiliated with any government entity" })}</span>
                  </div>
                  <div className="disclaimer-icon-box">
                    <span className="icon">💼</span>
                    <span className="text"><strong>{t("services", { defaultValue: "Services:" })}</strong> {t("servicesText", { defaultValue: "Travel consultancy and OMAN visa documentation support" })}</span>
                  </div>
                </div>

                {/* ── Summary ── */}
                <div className="disclaimer-section">
                  <div className="disclaimer-section-title">
                    {t("summaryTitle", { defaultValue: "Summary" })}
                    <span className="badge">{t("recap", { defaultValue: "Recap" })}</span>
                  </div>
                  <div className="disclaimer-highlight" style={{ borderLeftColor: "#294b5a" }}>
                    <p>{t("summaryText", { defaultValue: "By using this website, you acknowledge that we are a private service provider that assists in facilitating administrative procedures for travel documentation. We do not have the authority to approve or deny visa applications, and our services are separate from government processes." })}</p>
                  </div>
                </div>

                {/* ── Footer Note ── */}
                <div style={{ marginTop: "32px", paddingTop: "20px", borderTop: "1px solid #e8eef1" }}>
                  <p style={{ fontSize: "12px", color: "#94b0bc", textAlign: "center", marginBottom: 0 }}>
                    {t("disclaimerFooter", { defaultValue: "© 2026 silverjarz.com - All rights reserved. SilverJarz trading contracting" })}
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <DefaultFooter />
    </>
  );
};

export default LegalDisclaimer;